<app-dropdown
  [label]="label"
  [placeholder]="placeholder"
  [options]="filteredCitiesOptions"
  [(ngModel)]="value"
  [disabled]="disabled"
  [filter]="true"
  (filterChange)="onFilterCities($event)"
  [errorMessages]="errorMessages">
</app-dropdown>
